var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10433_7847)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33341 1.66666H16.6667C17.5834 1.66666 18.3334 2.41666 18.3334 3.33332V13.3333C18.3334 14.25 17.5834 15 16.6667 15H5.00008L1.66675 18.3333V3.33332C1.66675 2.41666 2.41675 1.66666 3.33341 1.66666ZM5.87202 11.6667H7.24512L7.69471 10.2847H9.88295L10.3317 11.6667H11.7048L9.61551 5.60605H7.96423L5.87202 11.6667ZM9.55819 9.28444L8.81354 6.99099H8.76619L8.0201 9.28444H9.55819ZM13.7989 11.6667V5.60605H12.5176V11.6667H13.7989Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10433_7847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChat);
export default __webpack_public_path__ + "static/media/aiChat.37d3a851855b705507433ea73b7a0804.svg";
export { ForwardRef as ReactComponent };